// extracted by css-extract-rspack-plugin
export default {"group":"BFbrFw0a88Guqrh2","default":"jkY24ah2KQQf4oyI AoooyxkQCoo8Wq6g","elevated":"SvsA2MhhuG46wnp3"};